import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Renderer2 } from '@angular/core';
import { ApiService } from '../api.service';
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from 'ngx-toastr';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit, AfterViewInit {
	user: any = { email: '', password: '' };
	year: number = new Date().getFullYear();
	loadershow: boolean = false;
	loginErrorshow: boolean = false;
	loginFormErr: string = "";
	adminAccess: any;
	data: any = null;
	step: number = 1;
	showQR = false;
	qrToShow: any;
	auth: any = { otp: null };
	qrStep = 1;
	acknowledgment: string = "Logging into this system affirms your **commitment to safety and compliance**. Please do not share login credentials.";

	constructor(private apiService: ApiService, private router: Router, private renderer: Renderer2, private toastr: ToastrService, private route: ActivatedRoute,) { }

	ngAfterViewInit(): void { }

	ngOnInit(): void {
		if (localStorage.getItem('vessel_token') != null && localStorage.getItem('vessel_token') != undefined) {
			this.gotoDashboard();
		}
	}

	submitForm(user: any) {
		this.loadershow = true;
		this.apiService.loginAPI(user).subscribe({
			next: (data: any) => {
				this.loadershow = false;
				data.vessel_ids = data.vessel_ids.filter((v) => v);
				if (!data.vessel_ids.length) {
					this.loginErrorshow = true;
					this.loginFormErr = "No vessel is linked to your account.";
					setTimeout(() => {
						this.loginErrorshow = false;
					}, 5000);
					return;
				}
				this.data = data;
				if (this.data.enable2fa && this.data.first_login) {
					this.step = 2;
					this.showQR = true;
					this.generateQR();
				} else if (this.data.enable2fa && !this.data.first_login) {
					this.step = 2;
					this.showQR = false;
					this.qrStep = 2;
				} else {
					this.proceedLogin();
				}
			}, error: (error: any) => {
				this.loadershow = false;
				this.loginErrorshow = true;
				this.loginFormErr = "Email Or Password is incorrect.";
				setTimeout(() => {
					this.loginErrorshow = false;
				}, 5000);
			}
		});
	}

	next() {
		this.qrStep = 2;
	}

	generateQR() {
		this.loadershow = true;
		let data: any = {
			Id: this.data.acc_user,
			user: this.data.emailId,
			userType: this.data.user_type
		};
		this.apiService.generate_qr(data).subscribe({
			next: (data: any) => {
				this.loadershow = false;
				this.createImageFromBlob(data);
			}, error: (error: any) => {
				this.loadershow = false;
				this.loginErrorshow = true;
				this.loginFormErr = "Something went wrong";
				setTimeout(() => {
					this.loginErrorshow = false;
				}, 5000);
			}
		});
	}

	createImageFromBlob(image: Blob) {
		let reader = new FileReader();
		reader.addEventListener("load", () => {
			this.qrToShow = reader.result;
		}, false);
		if (image) {
			reader.readAsDataURL(image);
		}
	}

	verifyOTP() {
		if (!this.auth.otp) {
			this.toastr.warning("Please enter OTP", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		this.loadershow = true;
		let data: any = {
			Id: this.data.acc_user,
			userType: this.data.user_type,
			otp: this.auth.otp
		};
		this.apiService.verifyGoogleAuthOTP(data).subscribe({
			next: (data: any) => {
				this.loadershow = false;
				this.proceedLogin();
			}, error: (error: any) => {
				this.loadershow = false;
				this.loginErrorshow = true;
				this.loginFormErr = "Invalid OTP";
				setTimeout(() => {
					this.loginErrorshow = false;
				}, 5000);
			}
		});
	}

	proceedLogin() {
		this.toastr.success("Logged in", 'Success', {
			timeOut: 3000,
			tapToDismiss: true,
			closeButton: true
		});
		localStorage.setItem('vessel_token', "Bearer " + this.data["token"]);
		localStorage.setItem('vessel_ids', JSON.stringify(this.data["vessel_ids"]));
		localStorage.setItem('first_name', this.data["firstName"]);
		localStorage.setItem('last_name', this.data["lastName"]);
		localStorage.setItem('email', this.data["email"]);
		this.gotoDashboard();
	}

	getLastParamValue(initialUrl: string, param: string): string | null {
		let current = initialUrl;
		let lastValue: string | null = null;
		while (true) {
			const dummy = new URL(current, 'http://dummy');
			const value = dummy.searchParams.get(param);
			if (!value) break;
			lastValue = value;
			current = decodeURIComponent(value);
		}
		return lastValue;
	}

	gotoDashboard() {
		let returnUrl = this.getLastParamValue(this.router.url, 'returnUrl') || this.apiService.getHomeURL();
		this.router.navigate([returnUrl]);
		/* this.router.navigate([this.apiService.getHomeURL()]); */
	}
}
